import styled from "@emotion/styled"
import { Button, Typography } from "@mui/material"
import { useTranslations } from "next-intl"
import { useEffect, useRef, useState } from "react"
import { CopyIcon, Desktop, useIsDesktop } from "ui"

const StyledCopyButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: fit-content;
  ${(p) => p.theme.breakpoints.down("md")} {
    padding: 0px !important;
    justify-content: flex-end;
  }
`

const CopyButton = ({ link }: { link: string }) => {
  const isDesktop = useIsDesktop()
  const t = useTranslations("Homepage")
  const [copySuccess, setCopySuccess] = useState(false)
  // CRITICAL FIX: Store timer ref to prevent memory leak
  const timerRef = useRef<NodeJS.Timeout | null>(null)

  // Cleanup timer on unmount
  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current)
      }
    }
  }, [])

  const handleCopyOrShare = async () => {
    if (isDesktop && navigator?.clipboard) {
      try {
        await navigator.clipboard.writeText(link)
        setCopySuccess(true)

        // Clear existing timer if any
        if (timerRef.current) {
          clearTimeout(timerRef.current)
        }

        timerRef.current = setTimeout(() => {
          setCopySuccess(false)
          timerRef.current = null
        }, 3000)
      } catch (err) {
        console.error("Copy failed", err)
      }
      return
    }
    if (!isDesktop && navigator?.share) {
      navigator?.share({ text: t("shareJob"), url: link })
    }
  }
  return (
    <StyledCopyButton onClick={handleCopyOrShare}>
      <CopyIcon />
      <Desktop arialive="polite">
        <Typography variant="body3">
          {copySuccess ? "הקישור הועתק בהצלחה" : t("shareJob")}
        </Typography>{" "}
      </Desktop>
    </StyledCopyButton>
  )
}
export default CopyButton
